<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog">
      <v-layout class="dialog-container" row justify-center>
        <v-card>
          <v-layout class="pt-4 pb-2 mr-4 justify-end" no-gutters>
            <v-icon color="accent" @click="$emit('closeModal')">close</v-icon>
          </v-layout>

          <v-card-text class="pa-0 ma-0">
            <v-layout v-if="!loading" no-gutters class="justify-center px-4">
              <div id="challenge"></div>
            </v-layout>

            <v-layout v-else no-gutters class="justify-center" style="padding: 200px">
              <v-progress-circular
                indeterminate
                size="100"
                color="#0067af"
              ></v-progress-circular>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import $http from '@/http.js';
export default {
  props: ["showModal3DS", "data3ds", "transactionId"],

  data() {
    return {
      dialog: false,
      loading: false,

      inverval: null,
      timeout: null,
    };
  },

  computed: {
    ...mapGetters(["body", "cardNumber", "postOrder", "instalmentAmount"]),
  },

  methods: {
    createIFrame() {
      try {
        var iframe = document.createElement("iframe");
        iframe.name = "myframe";
        iframe.id = "myframe";
        iframe.height = "492px";
        iframe.width = "492px";
        iframe.frameBorder = "0";

        const div = document.getElementById("challenge");

        div.appendChild(iframe);

        var idocument = iframe.contentWindow.document;

        var myform = idocument.createElement("form");
        myform.name = "myform";
        myform.setAttribute("target", "myframe");
        myform.setAttribute("method", "post");
        myform.setAttribute("action", this.data3ds.url);

        var hiddenField = idocument.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "creq");
        hiddenField.setAttribute("value", this.data3ds.creq);
        myform.appendChild(hiddenField);
        iframe.appendChild(myform);

        myform.submit();
      } catch (error) {
        alert("Error doing Challenge, try again later.");
      }
    },

    async checkPurchaseStatus() {
      let headers = { checkout: "one-checkout" };

      const { data } = await $http.get(
        `pdv/orders/charge/status?order_hash=${this.body.hash_pedido}`,
        null,
        { headers }
      );

      const { payments } = data;

      if (payments && payments.length) {
        let findedPayment = payments.find(
          (p) => Number(p.tid) === Number(this.transactionId)
        );

        if (findedPayment && findedPayment.status === "C") {
          this.$emit("closeModal");
          this.$store.dispatch("openSnackbar", {
            message: "Error ao validar",
            color: "error",
          });

          return;
        }
      }

      if (data.orderStatus === "P" && this.dialog) {
        setTimeout(() => {
          this.checkPurchaseStatus();
        }, 5000);
      } else if (data && data.status === "paid") {
        const postOrder = {
          ...this.postOrder,
          organizador: data.orderData.nome_organizador,
          cpf_organizador: data.orderData.org_cpf,
          cnpj_organizador: data.orderData.org_cnpj,
          mensagem: data.orderData.mensagem_conclusao_pedido,
          status: data.status === 'paid' ? 'Aprovado' : 'Em análise',
          card: ` no cartão terminado em ${this.cardNumber.substr(
            this.cardNumber.length - 4
          )}`,
          instalments: `em ${this.instalmentAmount}x`,
          hash_pedido: this.body.hash_pedido,
          payment: 'CC',
        };

        this.$store.dispatch('setPostOrder', postOrder);
        this.$store.commit('SET_TICKET_URL', data.orderData.ticketsUrl);
        this.$store.dispatch('setBody', {
          ...this.$store.getters.body,
          expiration: 0,
        });
        console.log('setPurchaseStarted - pixOrderStatus - false')
        this.$store.dispatch('setPurchaseStarted', false);
        localStorage.setItem('iframePurcheased', true);
        this.$store.dispatch('nextStep')
        this.$store.commit('SET_ORDER_DATA', data)
        this.$emit("closeModal", true);
      }
    },

    checkIfConfirmationIsValid() {
      this.timeout = setTimeout(() => {
        if (this.dialog) {
          this.$emit("closeModal");
          this.$store.dispatch("openSnackbar", {
            message: "Validação expirada",
            color: "error",
          });
        }
      }, 300000);
    },
  },

  watch: {
    showModal3DS(v) {
      this.dialog = v;
    },

    dialog(v) {
      if (v) {
        this.loading = false;
        this.$store.commit("SET_SECURE_3DS_OPEN", true);
        this.checkIfConfirmationIsValid();

        window.addEventListener("message", (e) => {
          if (e.data.status === "COMPLETE") {
            this.loading = true;
          }
        });

        setTimeout(() => {
          this.createIFrame();
        }, 600);

        this.checkPurchaseStatus();
      } else {
        clearTimeout(this.timeout);
      }
    },
  },
};
</script>
